
import i18next, { type InitOptions } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import ViteBackend from './ViteBackend'

export async function setupI18n(): Promise<void> {
  if (i18next.isInitialized) return

  const options: InitOptions = {
    fallbackLng: ['en', 'ja'],
    supportedLngs: ['ja', 'en', 'ko'],
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nLng',
    },
  }

  await i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(ViteBackend as any)
    .init(options)
}


export const i18n = i18next

export async function ensureNamespaces(namespaces: string | string[]) {
  const list = Array.isArray(namespaces) ? namespaces : [namespaces]
  await i18next.loadNamespaces(list)
}

export async function setLanguage(lng: string) {
  localStorage.setItem('i18nLng', lng)
  await i18next.changeLanguage(lng)
}
